<template>
	<v-container fluid> Report </v-container>
</template>

<script>
export default {
	name: 'Report',
	components: {},
	data: function () {
		return {};
	},
	methods: {},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$myStore.commit('setBreadcrumbs', [
			{ text: this.$t('modules.reports'), href: '/#/reports', disabled: false },
		]);
	},
};
</script>

<style scoped></style>
